/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MonitoredObjectFleetType,
    MonitoredObjectFleetTypeFromJSON,
    MonitoredObjectFleetTypeFromJSONTyped,
    MonitoredObjectFleetTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface AvgPricePerKmOfFleetType
 */
export interface AvgPricePerKmOfFleetType {
    /**
     * 
     * @type {string}
     * @memberof AvgPricePerKmOfFleetType
     */
    currency: string;
    /**
     * 
     * @type {number}
     * @memberof AvgPricePerKmOfFleetType
     */
    avgPricePerKm: number;
    /**
     * 
     * @type {MonitoredObjectFleetType}
     * @memberof AvgPricePerKmOfFleetType
     */
    fleetType: MonitoredObjectFleetType;
    /**
     * 
     * @type {number}
     * @memberof AvgPricePerKmOfFleetType
     */
    count: number;
}

export function AvgPricePerKmOfFleetTypeFromJSON(json: any): AvgPricePerKmOfFleetType {
    return AvgPricePerKmOfFleetTypeFromJSONTyped(json, false);
}

export function AvgPricePerKmOfFleetTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvgPricePerKmOfFleetType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currency': json['currency'],
        'avgPricePerKm': json['avg_price_per_km'],
        'fleetType': MonitoredObjectFleetTypeFromJSON(json['fleet_type']),
        'count': json['count'],
    };
}

export function AvgPricePerKmOfFleetTypeToJSON(value?: AvgPricePerKmOfFleetType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currency': value.currency,
        'avg_price_per_km': value.avgPricePerKm,
        'fleet_type': MonitoredObjectFleetTypeToJSON(value.fleetType),
        'count': value.count,
    };
}


